import * as React from 'react';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

export const Copyright = (props: any): JSX.Element => {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {'CopyRight © '}
      <Link color="inherit" href="https://cloudscape.hu/">
        CloudScape Innováció Kft.
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
};
